import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
// import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import { exerciseOptions, fetchData } from "./utils/fetchData";

const App = () => {
  const [allExercises, setAllExercises] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAllExercise = async () => {
      setIsLoading(true);
      const exercises = await fetchData(
        "https://exercisedb.p.rapidapi.com/exercises/",
        exerciseOptions
      );

      if (exercises) {
        setAllExercises(exercises);
      }
      setIsLoading(false);
    };

    fetchAllExercise();
  }, []);

  return (
    <>
      {isLoading ? (
        <div
          style={{
            margin: "220px auto",
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            border: "16px solid #f3f3f3",
            borderTop: "16px solid #ee2625",
            animation: "spin 1s linear infinite",
          }}
        ></div>
      ) : (
        <Box width="400px" sx={{ width: { xl: "1488px" } }} m="auto">
          <Navbar />
          <Outlet context={{ allExercises, isLoading }} />
          <Footer />
        </Box>
      )}
    </>
  );
};

export default App;
